import { AppLogo } from "@intrasys/core-ui";
import { format } from "date-fns";
import React, { ForwardedRef, useEffect, useState } from "react";
import useDarkMode from "@/hooks/useDarkMode";

interface ContentToPrintProps {
  data: TPicklist | undefined;
}

const PicklistContent = React.forwardRef(
  ({ data }: ContentToPrintProps, ref: ForwardedRef<HTMLDivElement>) => {
    const [pageNumber, setPageNumber] = useState(0);
    const { isDarkMode } = useDarkMode();
    console.log(isDarkMode);
    const items = [];
    useEffect(() => {
      if (!data || !data.items) return;
      if (data.items.data.length < 20) setPageNumber(1);
      if (data.items.data.length % 20 == 0)
        setPageNumber(data.items.data.length / 20);
      else setPageNumber(Math.ceil(data.items.data.length / 20));
    }, [pageNumber]);

    for (let i = 0; i < pageNumber; i++) {
      items.push(
        <div className="relative flex h-[279.4mm] w-[215.9mm] flex-col p-12 ">
          <div className="">
            <table className="w-full table-auto text-sm">
              <thead className="border-b-2">
                <tr className="h-10 text-left">
                  {/* <th>NAME</th> */}
                  <th>ITEM CODE</th>
                  <th>Ordered Quantity</th>
                  <th>Picked Quantity</th>
                  <th>Open Quantity</th>
                  <th className="text-right">SCANNED</th>
                  <th className="text-right">STATUS</th>
                </tr>
              </thead>
              <tbody>
                {data?.items.data
                  ?.slice(i * 20, (i + 1) * 20)
                  .map((item, idx) => (
                    <tr className="h-10" key={`stockVerification-item-${idx}`}>
                      {/* <td>
                        {item.name && item.name != "" ? item.name : "N/A"}
                      </td> */}
                      <td>
                        {item.assetTypeName && item.assetTypeName != ""
                          ? item.assetTypeName
                          : "N/A"}
                      </td>
                      <td>
                        {item.orderedQuantity? item.orderedQuantity
                          : "0"}
                      </td>
                      <td>
                        {item.pickedQuantity? item.pickedQuantity
                          : "0"}
                      </td>
                      <td>
                        {item.openQuantity? item.openQuantity
                          : "0"}
                      </td>
                      <td className="text-center">
                        {item.scannedOn != null ? "Yes" : "No"}
                      </td>
                      <td className="text-right">
                        {item.status}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {i === pageNumber - 1 ? (
            <div className="flex justify-end">
              <p className="pt-6 text-xl font-bold">
                {data?.items.filteredRecords} total items
              </p>
            </div>
          ) : null}
          <div className="absolute bottom-8 left-1/2">
            <p className="">
              {i + 2}/{pageNumber + 1}
            </p>
          </div>
        </div>
      );
    }
    return (
      <div
        className="flex flex-row justify-between justify-items-start text-gray-900 dark:text-gray-100"
        ref={ref}
      >
        <style>{`@page { size: 215.9mm 279.4mm !important; }`}</style>
        <div
          contentEditable={false}
          suppressContentEditableWarning={true}
          className=" outline-none"
        >
          <ul className="space-y-2 ">
            <li className="bg-white dark:bg-gray-900">
              <div className="relative flex h-[279.4mm] w-[215.9mm] flex-col p-12">
                <div className="mt-32 flex justify-between">
                  <div>
                    <p className="pb-2 text-4xl">ShunZhou</p>
                    <p className="text-sm text-gray-400">
                      3 Hamilton Road, Shun Zhou Building,
                    </p>
                    <p className="text-sm text-gray-400">Singapore 209176</p>
                  </div>
                  <div>
                    <AppLogo className="" size="base" mode={isDarkMode ? "light" : "dark"} />
                  </div>
                </div>
                <div className="flex justify-between pt-16">
                  <div>
                    {/* <p>{format(new Date(), "yyyy-MM-dd")}</p> */}
                    <p className="pb-3 text-4xl font-bold">
                      Picklist
                    </p>
                  </div>
                  <div className="pl-2 text-left">
                    {/* <p className="text-gray-400">CLIENT</p>
                      <p className="font-bold">Tony Stark</p>
                      <p className="text-sm">Avengers Mansion</p>
                      <p className="text-sm">890 Fifth Avenue</p>
                      <p className="text-sm">Manhattan New York 10004</p> */}
                    <p className="text-sm font-bold">
                      NAME:{" "}
                      <span className="pl-1 font-normal">{data?.name}</span>
                    </p>
                    <p className="text-sm font-bold">
                      DESC:{" "}
                      <span className="pl-1 font-normal">
                        {data?.description}
                      </span>
                    </p>
                    <p className="text-sm font-bold">
                      CREATED DATE:{" "}
                      <span className="pl-1 font-normal">
                        {format(new Date(), "dd-MM-yy HH:mm")}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="absolute bottom-8 left-1/2">
                  <p className="">
                    {1}/{pageNumber + 1}
                  </p>
                </div>
              </div>
            </li>
            {items.map((item, index) => (
              <li key={index} className="bg-white dark:bg-gray-900">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
);

export default PicklistContent;